/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { BaseTrendChartStore } from '../stores';

export const BaseTrendChartContext = createContext<BaseTrendChartStore>({} as BaseTrendChartStore);
